import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center w-full mb-6" }
const _hoisted_2 = { class: "text-[#101828] text-3xl font-semibold mb-0 capitalize" }
const _hoisted_3 = { class: "flex flex-row gap-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, null, -1)
const _hoisted_5 = { class: "text-base flex justify-between" }

import { ref } from 'vue';

import TutorialModalComponent from "@/modules/main/components/TutorialModalComponent.vue";
import SchoolFilterComponent from "@/components/global/SchoolFilterComponent.vue";
import { useFilterStore } from "@/stores/filterStore";
import { useUserStore } from "@/stores/userStore";
import { ArrowPathIcon } from "@heroicons/vue/24/outline";
import { useDataStore } from "@/stores/dataStore";

import { watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeaderComponent',
  props: {
  pageHeading: {
    type: String,
    default: "",
  },
  tutorialContent: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;

const filterStore = useFilterStore();
const userStore = useUserStore();
const dataStore = useDataStore();



const showTutorialModal = ref(false);

watch(() => filterStore.selectedFilters.schoolGroup, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    filterStore.selectSchoolGroup(newVal);
  }
});

watch(() => filterStore.selectedFilters.school, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    filterStore.selectSchool(newVal);
  }
});


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.pageHeading), 1),
      _createElementVNode("div", _hoisted_3, [
        (_unref(filterStore).schoolGroupOptions.length > 1 && _unref(userStore).isInternalAdmin)
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 0,
              type: "search",
              name: "selectedSchoolGroup",
              placeholder: 'Select School Group',
              searchOptions: _unref(filterStore).schoolGroupOptions,
              modelValue: _unref(filterStore).selectedFilters.schoolGroup,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filterStore).selectedFilters.schoolGroup) = $event))
            }, null, 8, ["searchOptions", "modelValue"]))
          : _createCommentVNode("", true),
        (_unref(userStore).isInternalAdmin || _unref(userStore).isSchoolGroupAdmin || _unref(userStore).isMultipleSchoolAdmin)
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 1,
              type: "search",
              name: "selectedSchool",
              placeholder: 'Select School',
              searchOptions: _unref(filterStore).schoolOptions,
              modelValue: _unref(filterStore).selectedFilters.school,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filterStore).selectedFilters.school) = $event))
            }, null, 8, ["searchOptions", "modelValue"]))
          : _createCommentVNode("", true),
        (_unref(userStore).isInternalAdmin || _unref(userStore).isSchoolGroupAdmin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg flex flex-row items-center gap-1.5",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(dataStore).fetchNewData && _unref(dataStore).fetchNewData(...args)))
            }, [
              _createVNode(_unref(ArrowPathIcon), {
                class: "-ml-0.5 h-5 w-5",
                "aria-hidden": "true"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_4
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createVNode(SchoolFilterComponent, {
        "onUpdate:searchQuery": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:searchQuery', $event)))
      })
    ]),
    _createVNode(TutorialModalComponent, {
      show: showTutorialModal.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((showTutorialModal).value = $event))
    }, {
      headerSlot: _withCtx(() => [
        _createTextVNode(" Tutorial ")
      ]),
      descriptionSlot: _withCtx(() => [
        _createTextVNode(" Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus commodi, suscipit, unde deleniti distinctio qui culpa vero repudiandae eum provident laudantium officia laboriosam harum iste fugit nobis minus, consectetur dolorem. ")
      ]),
      strapiContent: _withCtx(() => [
        _createTextVNode(" Strapi content to go here... ")
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})